import { render, staticRenderFns } from "./TodoEditSkeleton.vue?vue&type=template&id=9c720050&scoped=true"
import script from "./TodoEditSkeleton.vue?vue&type=script&lang=ts"
export * from "./TodoEditSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c720050",
  null
  
)

export default component.exports